module.exports = __webpack_public_path__ + "static/media/53.c31d55be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/53.svg
// module id = 177
// module chunks = 0